export enum PerfilIdentificadorEnum {
    ADM = 'ADM',
    SUPN1 = 'SUPN1',
}
